import React from "react";

const CheckboxField = ({ checked, onChange, label, required }) => {
  return (
    <label className="checkbox-label">
      <input
        type="checkbox"
        checked={checked}
        onChange={(e) => onChange(e.target.checked)}
        required={required}
        className="checkbox-input"
      />
      <span className="checkbox-text">{label}</span>
    </label>
  );
};

export default CheckboxField;
